import { SyntheticEvent } from 'react';
import {
    FormControl,
    FormControlProps,
    FormHelperText,
    Grid,
    IconButton,
    InputAdornment,
    InputLabel,
    OutlinedInput,
} from '@mui/material';
import { Clear as ClearIcon, Search as SearchIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

type SttFormSearchProps = {
    grid?: boolean;
    size?: FormControlProps['size'];
    caption?: string;
    onChange: ({
        name,
        value,
    }: {
        name: string | undefined;
        value: unknown;
    }) => void;
    defVal: string;
    name?: string;
    disabled?: boolean;
    readOnly?: boolean;
    onClickSearch?: (event: SyntheticEvent) => void;
    onEnterKey?: (event: SyntheticEvent) => void;
    onClean?: () => void;
    error?: boolean;
    helperText?: string;
    xs?: number;
    sm?: number;
    md?: number;
    lg?: number;
    xl?: number;
    [key: string]: any;
};

/**
 * Form search
 */
export function SttFormSearch({
    grid = false,
    size = 'small',
    caption,
    onChange,
    defVal,
    name = '',
    disabled,
    readOnly = false,
    onClickSearch,
    onEnterKey,
    onClean,
    error,
    helperText,
    xs,
    sm,
    md,
    lg,
    xl,
    ...rest
}: SttFormSearchProps) {
    const { t } = useTranslation();

    const content = (
        <FormControl variant="outlined" size={size} fullWidth error={error}>
            <InputLabel>{caption || t('generic.search')}</InputLabel>
            <OutlinedInput
                disabled={disabled}
                type="text"
                value={defVal}
                onChange={(ev: any) => {
                    onChange({
                        name: name || undefined,
                        value: ev.target.value,
                    });
                }}
                endAdornment={
                    <InputAdornment position="end">
                        {onClean && defVal && !readOnly && (
                            <IconButton onClick={() => onClean()}>
                                <ClearIcon />
                            </IconButton>
                        )}

                        {onClickSearch && !readOnly && (
                            <IconButton onClick={onClickSearch}>
                                <SearchIcon />
                            </IconButton>
                        )}
                    </InputAdornment>
                }
                label={caption || t('generic.search')}
                onKeyUp={(event: any) => {
                    if (event.key === 'Enter') {
                        if (onEnterKey) {
                            onEnterKey(event);
                        } else if (onClickSearch) {
                            onClickSearch(event);
                        }
                    }
                }}
            />
            {helperText && <FormHelperText>{helperText}</FormHelperText>}
        </FormControl>
    );
    const sizeProps = { xs, sm, md, lg, xl };
    return grid ? (
        <Grid size={sizeProps} {...rest}>
            {content}
        </Grid>
    ) : (
        content
    );
}
